/*
  search-suggest.js — 検索窓の候補（自前）（オンラインショップ #60）

  概要  : Shopify 標準の予測検索は日本語に対応していない（/search/suggest が 417）ため、
          全商品の名前・メーカー・タグの小さな一覧（templates/collection.search-index.liquid）を読み、
          ブラウザで照合して検索窓の下に候補を出す。
          平仮名とカタカナ・全角と半角の違いを吸収し、言い換え（ほうれん草＝ホウレンソウ 等）は下の辞書で当てる。
          複数の語は全部含むもの（AND）。Enter はふだんどおり検索結果ページへ（候補を矢印で選んだときはその商品へ）。
  Inputs: /collections/all?view=search-index（250件ずつ・JSON）、ヘッダー等の input[name="q"]
  Outputs: 検索窓の下の候補リスト（DOM）、window.SeedSearch（load・search・norm。検索結果ページが使う）
  Env   : なし（テーマの assets。layout/theme.liquid で読み込む）
  Run   : テーマへ置き、theme.liquid の </body> の前に <script src="{{ 'search-suggest.js' | asset_url }}" defer></script>
*/
(function () {
  'use strict';

  // 言い換えの辞書（1行＝同じものを指す言葉の組）。品目・病名・メーカーの呼び方を足していく
  var SYNONYMS = [
    ['ほうれんそう', 'ほうれん草', '法蓮草'],
    ['こまつな', '小松菜', 'コマツ菜'],
    ['とうもろこし', 'トウモロコシ', 'スイートコーン', 'コーン', '玉蜀黍'],
    ['ぶろっこりー', 'ブロッコリ'],
    ['たまねぎ', '玉ねぎ', '玉葱', 'オニオン'],
    ['きゅうり', '胡瓜'], ['なす', '茄子'], ['かぼちゃ', '南瓜'], ['すいか', '西瓜'],
    ['ねぎ', '葱'], ['だいこん', '大根'], ['にんじん', '人参'], ['はくさい', '白菜'],
    ['しゅんぎく', '春菊'], ['みずな', '水菜'], ['ちんげんさい', 'チンゲン菜', '青梗菜'],
    ['べとびょう', 'べと病'], ['いちょうびょう', '萎凋病'], ['いおうびょう', '萎黄病'],
    ['ねこぶびょう', '根こぶ病', '根こぶ'], ['しろさびびょう', '白さび病'], ['ばんちゅう', '晩抽'],
    ['さかた', 'サカタのタネ'], ['たきい', 'タキイ種苗'], ['ときた', 'トキタ種苗'], ['むさしの', '武蔵野種苗園']
  ];
  var MAX = 8;
  var CACHE_KEY = 'ss-index-v2';
  var CACHE_MS = 30 * 60 * 1000;

  function norm(s) {
    s = String(s || '').normalize('NFKC').toLowerCase();
    s = s.replace(/[ァ-ヶ]/g, function (c) { return String.fromCharCode(c.charCodeAt(0) - 0x60); });  // カタカナ→平仮名
    return s.replace(/[\s「」『』()（）\[\]【】®™・,、。'"]/g, '');
  }
  var GROUPS = SYNONYMS.map(function (g) { return g.map(norm); });

  function expand(tok) {
    var terms = [tok];
    GROUPS.forEach(function (g) {
      for (var i = 0; i < g.length; i++) {
        if (g[i].indexOf(tok) === 0 || tok === g[i]) { g.forEach(function (m) { if (terms.indexOf(m) < 0) terms.push(m); }); break; }
      }
    });
    return terms;
  }

  var index = null, loading = null;
  function root() { return (window.Shopify && Shopify.routes && Shopify.routes.root) || '/'; }
  function load() {
    if (index) return Promise.resolve(index);
    if (loading) return loading;
    try {
      var c = JSON.parse(sessionStorage.getItem(CACHE_KEY) || 'null');
      if (c && Date.now() - c.at < CACHE_MS) { index = c.items.map(prep); return Promise.resolve(index); }
    } catch (e) {}
    var items = [];
    function page(n) {
      return fetch(root() + 'collections/all?view=search-index&page=' + n, { credentials: 'same-origin' })
        .then(function (r) { return r.text(); })
        .then(function (t) {
          var j = JSON.parse(t);
          items = items.concat(j.items || []);
          return (j.more && n < 20) ? page(n + 1) : items;
        });
    }
    loading = page(1).then(function (all) {
      try { sessionStorage.setItem(CACHE_KEY, JSON.stringify({ at: Date.now(), items: all })); } catch (e) {}
      index = all.map(prep);
      return index;
    }).catch(function () { loading = null; return []; });
    return loading;
  }
  function prep(it) {
    it._t = norm(it.t);
    it._h = norm([it.t, it.v, it.y, (it.g || []).join(' ')].join(' '));
    return it;
  }

  function search(q) {
    var toks = String(q || '').normalize('NFKC').split(/\s+/).map(norm).filter(Boolean);
    if (!toks.length || !index) return [];
    var sets = toks.map(expand);
    var out = [];
    index.forEach(function (it) {
      var score = 0;
      for (var i = 0; i < sets.length; i++) {
        var best = 0;
        sets[i].forEach(function (term) {
          var p = it._t.indexOf(term);
          if (p === 0) best = Math.max(best, 12);
          else if (p > 0) best = Math.max(best, 10);
          else if (it._h.indexOf(term) >= 0) best = Math.max(best, 1);
        });
        if (!best) return;  // どれかの語が当たらなければ候補にしない（AND）
        score += best;
      }
      out.push({ it: it, s: score });
    });
    out.sort(function (a, b) { return b.s - a.s || a.it._t.localeCompare(b.it._t, 'ja'); });
    return out.map(function (x) { return x.it; });
  }

  var css = '.ss-panel{position:absolute;left:0;right:0;top:100%;z-index:30;background:rgb(var(--color-background,255,255,255));border:1px solid rgba(var(--color-foreground,18,18,18),.2);box-shadow:0 6px 18px rgba(0,0,0,.12);max-height:70vh;overflow:auto;text-align:left}' +
    '.ss-panel[hidden]{display:none}.ss-item{display:flex;gap:.8rem;align-items:center;padding:.6rem 1rem;color:inherit;text-decoration:none;border-bottom:1px solid rgba(var(--color-foreground,18,18,18),.08)}' +
    '.ss-item:hover,.ss-item.is-active{background:rgba(var(--color-foreground,18,18,18),.06)}.ss-item img,.ss-noimg{width:44px;height:44px;object-fit:contain;flex:none;background:rgba(var(--color-foreground,18,18,18),.04)}' +
    '.ss-t{font-size:1.4rem;line-height:1.3}.ss-m{font-size:1.2rem;color:rgba(var(--color-foreground,18,18,18),.6)}.ss-all{display:block;padding:.8rem 1rem;font-size:1.3rem;text-decoration:underline}.ss-none{padding:.8rem 1rem;font-size:1.3rem;color:rgba(var(--color-foreground,18,18,18),.6)}';

  function attach(input) {
    if (input._ss) return;
    input._ss = true;
    input.setAttribute('autocomplete', 'off');
    var form = input.closest('form') || input.parentNode;
    var host = input.closest('.field') || input.parentNode;
    if (getComputedStyle(host).position === 'static') host.style.position = 'relative';
    var panel = document.createElement('div');
    panel.className = 'ss-panel'; panel.hidden = true; panel.setAttribute('role', 'listbox');
    host.appendChild(panel);
    var active = -1, timer;

    function render() {
      var q = input.value;
      if (!norm(q)) { panel.hidden = true; return; }
      load().then(function () {
        if (input.value !== q) return;
        var hits = search(q);
        panel.innerHTML = '';
        active = -1;
        if (!hits.length) {
          var none = document.createElement('div'); none.className = 'ss-none'; none.textContent = '候補がありません';
          panel.appendChild(none);
        }
        hits.slice(0, MAX).forEach(function (it) {
          var a = document.createElement('a'); a.className = 'ss-item'; a.href = it.u; a.setAttribute('role', 'option');
          if (it.i) { var im = document.createElement('img'); im.src = it.i; im.alt = ''; im.loading = 'lazy'; a.appendChild(im); }
          else { var ni = document.createElement('span'); ni.className = 'ss-noimg'; a.appendChild(ni); }
          var tx = document.createElement('span');
          var t = document.createElement('div'); t.className = 'ss-t'; t.textContent = it.t;
          var m = document.createElement('div'); m.className = 'ss-m'; m.textContent = [it.v, it.p].filter(Boolean).join('　');
          tx.appendChild(t); tx.appendChild(m); a.appendChild(tx);
          panel.appendChild(a);
        });
        var all = document.createElement('a'); all.className = 'ss-all';
        all.href = (form.getAttribute('action') || root() + 'search') + '?q=' + encodeURIComponent(q);
        all.textContent = '「' + q + '」で検索' + (hits.length ? '（候補 ' + hits.length + '件）' : '');
        panel.appendChild(all);
        panel.hidden = false;
      });
    }
    function move(d) {
      var items = panel.querySelectorAll('.ss-item');
      if (!items.length) return;
      active = (active + d + items.length) % items.length;
      items.forEach(function (x, i) { x.classList.toggle('is-active', i === active); });
      items[active].scrollIntoView({ block: 'nearest' });
    }
    input.addEventListener('focus', function () { load(); if (norm(input.value)) render(); });
    input.addEventListener('input', function () { clearTimeout(timer); timer = setTimeout(render, 80); });
    input.addEventListener('keydown', function (e) {
      if (panel.hidden) return;
      if (e.key === 'ArrowDown') { e.preventDefault(); move(1); }
      else if (e.key === 'ArrowUp') { e.preventDefault(); move(-1); }
      else if (e.key === 'Escape') { panel.hidden = true; }
      else if (e.key === 'Enter' && active >= 0) { e.preventDefault(); location.href = panel.querySelectorAll('.ss-item')[active].href; }
    });
    document.addEventListener('click', function (e) { if (!host.contains(e.target)) panel.hidden = true; });
  }

  // 検索結果ページ（sections/search-results.liquid）からも同じ一覧と照合を使う
  window.SeedSearch = { load: load, search: search, norm: norm };

  function init() {
    if (!document.getElementById('ss-style')) {
      var st = document.createElement('style'); st.id = 'ss-style'; st.textContent = css; document.head.appendChild(st);
    }
    document.querySelectorAll('form[action$="/search"] input[name="q"], form[role="search"] input[name="q"]').forEach(attach);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
